import TubCommon from "./tubCommon";

export default class JettedTub extends TubCommon {
  constructor(isChild) {
    super(isChild);
    this.partId = 'jetted_tub';
    this.bottomTubId = "jetted_tub";
    this.visible = true;
    this.partName = 'Jetted Tub';
    this.translateId = "visualizer.bathroom.shower_tub_combo.jetted_tub";
    this.isStoneFeature = false;
    this.disableOnHomeSections = true;
  }
}
